import { DashboardFolderTreeNodeT } from 'business/definitions';

/**
 * Recursively calculates the total number of dashboards in a folder and all its subfolders.
 */
export const getTotalDashboardsCount = (
    folder: DashboardFolderTreeNodeT,
): number => {
    let count = folder.dashboards.length;
    for (const childFolder of folder.folders) {
        count += getTotalDashboardsCount(childFolder);
    }
    return count;
};
